<div class="container">
  <nz-steps nzType="navigation" nzSize="small" [nzCurrent]="current">
    @for (step of steps; track step) {
      <nz-step nzTitle="{{ step | translate }}" class="paragraph-small regular"></nz-step>
    }
  </nz-steps>
</div>
